<template>
  <vx-card title-color="primary" class="fill">
    <filtros
      :filtersView="configuration"
      :periodos="periodos"
      :source="source"
      v-on:filtros-aplicados="onChangeFilters"
      :clear="clearFilters"
    />
    <div style="clear: both;border-bottom: solid 1px #ccc;margin-bottom: 10px"></div>
    <div v-if="firstSearch" class="message">
      Para realizar una busqueda agrega algunos filtros y luego presiona el boton "Aplicar Filtros"
      arriba a la izquierda.
    </div>
    <div v-if="noResults" class="message">
      Oh no! no logramos encontrar nada con los filtros que ingresaste, verificalos o prueba
      quitando algunos.
    </div>
    <div v-if="loading" class="message">
      Buscando los elementos que coincidan con los filtros de busqueda
      ingresados...
    </div>
    <vs-row class="bg-white shadow py-5 px-3 mb-4">
      <vs-col vs-lg="6">
        <b>Nombre</b>
      </vs-col>
      <vs-col vs-lg="5">
        <b>Autor</b>
      </vs-col>
      <vs-col vs-lg="1">
        <b>...</b>
      </vs-col>
    </vs-row>
    <open-text-row
      v-for="(item, index) in resultAguasAndinas"
      :key="`object-${index}`"
      :doc="item"
      :source="source"
      @download="download"
    />
    <!-- Paginacion (solo cuando source es eGestion y hay mas de una pagina) -->
    <vs-row
      v-if="source === 'egestion' && pagination.totalPages > 1"
      class="py-4 justify-content-center align-items-center"
    >
      <vs-col vs-lg="12" class="text-center">
        <vs-button
          size="small"
          :disabled="pagination.page <= 1"
          @click="prevPage"
          class="mr-2"
        >
          Anterior
        </vs-button>
        <span class="mx-3">
          Pagina {{ pagination.page }} de {{ pagination.totalPages }}
          ({{ pagination.total }} documentos)
        </span>
        <vs-button
          size="small"
          :disabled="pagination.page >= pagination.totalPages"
          @click="nextPage"
          class="ml-2"
        >
          Siguiente
        </vs-button>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
import { mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFileImage, faFile, faFileVideo, faFileAudio, faFileCsv, faFileAlt,
  faFileArchive, faFilePdf, faFilePowerpoint, faFileExcel, faFileWord,
  faExclamationCircle, faCheckCircle, faCircle, faCalendar, faCalendarCheck,
  faCalendarTimes, faTimesCircle, faUserCircle, faFolder, faArrowRight, faDownload
} from '@fortawesome/free-solid-svg-icons';

import configFiltros from '@/febos/chile/dnt/vistas/configFiltros';
import Filtros from '@/febos/global/_vue/componentes/FiltrosOpenText';
import OpenTextRow from '@/febos/chile/dnt/vistas/OpenTextRow';
import { DATE_RANGES } from '@/febos/chile/commons/dateCommons';
import { removeSearchParams, updateSearchParams } from '@/febos/global/utils/router';

// Maximo 12 meses para busqueda en eGestion
const ALLOWED_DATE_RANGES = [
  'ultimas4semanas',
  'esteMes',
  'esteMesConAnterior',
  'ultimos3meses',
  'ultimos6meses',
  'ultimos9meses',
  'ultimos12meses',
  'personalizado'
];
const DATE_RANGES_OPEN_TEXT = DATE_RANGES.filter(
  (range) => ALLOWED_DATE_RANGES.includes(range.valor)
);

library.add(
  faFileImage,
  faFile,
  faFileVideo,
  faFileAudio,
  faFileCsv,
  faFileAlt,
  faFileArchive,
  faFilePdf,
  faFilePowerpoint,
  faFileExcel,
  faFileWord,
  faFolder,
  faExclamationCircle,
  faCheckCircle,
  faCircle,
  faCalendar,
  faCalendarCheck,
  faCalendarTimes,
  faTimesCircle,
  faUserCircle,
  faArrowRight,
  faDownload
);
export default {
  name: 'OpenText',
  components: {
    Filtros,
    OpenTextRow
  },
  data() {
    return {
      configuration: configFiltros,
      periodos: DATE_RANGES_OPEN_TEXT,
      firstSearch: false,
      firstHandleFilters: true,
      result: [],
      loading: false,
      loadingDownload: false,
      resultAguasAndinas: [],
      versions: [],
      source: null,
      pagination: {
        page: 1,
        pageSize: 50,
        total: 0,
        totalPages: 0
      },
      lastFiltros: ''
    };
  },
  watch: {
    loading(value) {
      if (value) {
        this.$vs.loading({ color: '#aaaaaa', text: 'Espera un momento por favor' });
      } else {
        this.$vs.loading.close();
      }
    },
    loadingDownload(value) {
      if (value) {
        this.$vs.loading({ color: '#aaaaaa', text: 'Espera un momento por favor' });
      } else {
        this.$vs.loading.close();
      }
    }
  },
  computed: {
    noResults() {
      return !this.firstSearch && !this.loading && this.resultAguasAndinas.length === 0;
    }
  },
  methods: {
    ...mapActions('Modals', [
      'showModals',
      'closeModal'
    ]),
    ...mapActions('Dnts', [
      'loadOpenText',
      'getIdVersionOpenText',
      'getLinkOpenText'
    ]),

    clearList() {
      this.firstSearch = true;
      this.resultAguasAndinas = [];
      this.versions = [];
    },
    clearFilters() {
      removeSearchParams(['filters']);
      updateSearchParams({ page: 1 });
      this.$router.go();
    },
    async onChangeFilters(filtros, onMounted = false) {
      if (this.firstHandleFilters && !onMounted) {
        this.firstHandleFilters = false;
      } else {
        if (this.firstSearch) {
          this.firstSearch = false;
        }
        this.lastFiltros = filtros;
        this.pagination.page = 1;
        await this.fetchDocuments();
      }
    },
    async fetchDocuments() {
      this.loading = true;
      try {
        const arrayFiltros = this.lastFiltros.split('|').map((filtro) => filtro.split(':'));
        const criterios = Object.fromEntries(arrayFiltros);
        const payload = {
          params: {
            metodo: 'librerias_form_docs',
            library: 'AGUASANDINAS',
            form: 'FORM_ING_REGULACIO',
            descripcion: 'ESCRITORIO_DIGITAL',
            page: this.pagination.page,
            pageSize: this.pagination.pageSize
          },
          data: {
            criterios
          }
        };
        const response = await this.loadOpenText(payload);
        this.resultAguasAndinas = response.data.list;
        this.source = response.source || null;

        if (response.pagination) {
          this.pagination = { ...this.pagination, ...response.pagination };
        } else {
          this.pagination.total = response.data.set ? response.data.set.total : 0;
          this.pagination.totalPages = 1;
        }
      } finally {
        this.loading = false;
      }
    },
    async nextPage() {
      if (this.pagination.page < this.pagination.totalPages) {
        this.pagination.page += 1;
        await this.fetchDocuments();
      }
    },
    async prevPage() {
      if (this.pagination.page > 1) {
        this.pagination.page -= 1;
        await this.fetchDocuments();
      }
    },
    async goToPage(page) {
      if (page >= 1 && page <= this.pagination.totalPages) {
        this.pagination.page = page;
        await this.fetchDocuments();
      }
    },
    async downloadVersion(numberDocument, idVersion, extensionArchive) {
      this.loadingDownload = true;
      const extensionFile = extensionArchive.includes('\'')
        ? `.${extensionArchive.split('\'')[0]}`
        : `.${extensionArchive}`;
      try {
        const payloadIdVersion = {
          metodo: 'librerias_form_docs_version',
          library: 'library',
          idDoc: numberDocument,
          idVersion,
          extension: extensionFile,
          nombre: numberDocument
        };
        const responseUrl = await this.getLinkOpenText(payloadIdVersion);
        window.open(responseUrl, '_blank');
      } finally {
        this.loadingDownload = false;
      }
    },
    async download(numberDocument) {
      this.loadingDownload = true;
      try {
        const payload = {
          metodo: 'librerias_form_docs_versions',
          library: 'AGUASANDINAS',
          idDoc: numberDocument
        };
        this.versions = await this.getIdVersionOpenText(payload);
        await this.downloadVersion(
          numberDocument,
          this.versions[this.versions.length - 1].VERSION_ID,
          this.versions[this.versions.length - 1].FILE_EXTENSION
        );
      } finally {
        this.loadingDownload = false;
      }
    }
  },
  created() {
    this.resultAguasAndinas = [];
  }
};
</script>

<style lang="scss" scoped>
.message {
  border: solid 1px #ccc;
  border-radius: 5px;
  padding: 20px;
}

.kind, .detail {
  display: inline-block;
  height: 60px;
  vertical-align: top;
}

.detail {
  width: calc(100% - 80px);
}

.name {
  font-size: 16px;
  font-weight: bold;
}

.kind {
  width: 60px;
  text-align: center;
  margin-right: 10px;
  padding-right: 10px;
  border-right: solid 1px #eee;
}

.result {
  padding: 10px;
  border-bottom: solid 1px #aaa;
  overflow-y: hidden;
}

.result:hover {
  background-color: #eee;
  cursor: pointer;
  box-shadow: 0 5px 5px -2px rgb(var(--vs-primary));
}

.actions {
  float: right;
  top: 5px;
  right: 10px;
}

.action {
  float: none;
  border: solid 1px rgb(var(--vs-primary));
  background-color: white;
  border-radius: 5px;
  display: inline-block;
  color: rgb(var(--vs-primary));
  margin-left: 5px;
  padding-left: 5px;
  padding-right: 5px;
}

.action:hover {
  cursor: pointer;
  background-color: rgb(var(--vs-primary));
  color: white;
}

.action-version {
  font-size: 16px;
  font-weight: bold;
}

.action-version:hover {
  cursor: pointer;
  color: rgb(var(--vs-primary));
}

.keywords span {
  color: #aaa;
  font-size: 11px;
}
</style>
